import { render, staticRenderFns } from "./manageGroupView.vue?vue&type=template&id=2344243c&"
import script from "./manageGroupView.vue?vue&type=script&lang=js&"
export * from "./manageGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports